import React from "react";

const LoadingScreen = () => {
  return (
    <>
      <div className="loading-overlay">
        <div className="spinner">
          <div className="dot dot1"></div>
          <div className="dot dot2"></div>
          <div className="dot dot3"></div>
          <div className="dot dot4"></div>
        </div>
        {/* <p className="loading-text">Loading...</p> */}
      </div>

      <style>{`
        .loading-overlay {
           position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(46, 43, 43, 0.9);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 5000;
        }

        .loading-text {
          margin-top: 20px;
          font-size: 1.5rem;
          font-weight: 600;
          color: #333;
          font-family: "Segoe UI", sans-serif;
          letter-spacing: 1px;
        }

        .spinner {
          display: flex;
          justify-content: space-between;
          width: 60px;
          height: 60px;
          position: relative;
        }

        .dot {
          width: 15px;
          height: 15px;
          background: linear-gradient(45deg, #ffffffff, #ffffffff);
          border-radius: 50%;
          animation: scale 1.2s infinite ease-in-out;
        }

        .dot1 { animation-delay: 0s; }
        .dot2 { animation-delay: 0.2s; }
        .dot3 { animation-delay: 0.4s; }
        .dot4 { animation-delay: 0.6s; }

        @keyframes scale {
          0%, 100% { transform: scale(0.5); opacity: 0.5; }
          50% { transform: scale(1); opacity: 1; }
        }
      `}</style>
    </>
  );
};

export default LoadingScreen;
